import { useEffect } from "react";

export function useSEO({ title, description, url, image, type = "website" }) {
  useEffect(() => {
    document.title = title;
    
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(name.startsWith("og:") ? "property" : "name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description);
    }
    if (title) {
      setMeta("og:title", title);
    }
    if (url) {
      setMeta("og:url", url);
    }
    if (image) {
      setMeta("og:image", image);
    }
    setMeta("og:type", type);
    setMeta("og:site_name", "Scutersh");
  }, [title, description, url, image, type]);
}

export function JsonLdProduct({ name, description, price, currency = "EUR", image, url, availability = "InStock" }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name,
      description,
      image,
      url,
      offers: {
        "@type": "Offer",
        price,
        priceCurrency: currency,
        availability: `https://schema.org/${availability}`,
        seller: {
          "@type": "Organization",
          name: "Scutersh",
        },
      },
    });
    document.head.appendChild(script);
    return () => { document.head.removeChild(script); };
  }, [name, description, price, currency, image, url, availability]);
  return null;
}

export function JsonLdOrganization() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Scutersh",
      url: window.location.origin,
      logo: "https://customer-assets.emergentagent.com/job_509254e3-4fbd-4a68-8194-b9dcfb6ff3e4/artifacts/bylh1er6_Image.jpg",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+40792250058",
        contactType: "sales",
        availableLanguage: ["Romanian", "English", "French"],
      },
      address: {
        "@type": "PostalAddress",
        addressLocality: "Bucuresti",
        addressCountry: "RO",
      },
    });
    document.head.appendChild(script);
    return () => { document.head.removeChild(script); };
  }, []);
  return null;
}
